
export type ConversionCategory = 'length' | 'area' | 'volume' | 'mass' | 'temperature' | 'speed' | 'time' | 'pressure' | 'energy' | 'power' | 'data' | 'cooking';

export type ConversionType = {
  from: string;
  to: string;
  category: ConversionCategory;
};

export const conversionTypes: ConversionType[] = [
  // Length
  { from: 'millimeters', to: 'centimeters', category: 'length' },
  { from: 'centimeters', to: 'millimeters', category: 'length' },
  { from: 'centimeters', to: 'meters', category: 'length' },
  { from: 'meters', to: 'centimeters', category: 'length' },
  { from: 'meters', to: 'kilometers', category: 'length' },
  { from: 'kilometers', to: 'meters', category: 'length' },
  { from: 'inches', to: 'centimeters', category: 'length' },
  { from: 'centimeters', to: 'inches', category: 'length' },
  { from: 'feet', to: 'meters', category: 'length' },
  { from: 'meters', to: 'feet', category: 'length' },
  { from: 'yards', to: 'meters', category: 'length' },
  { from: 'meters', to: 'yards', category: 'length' },
  { from: 'miles', to: 'kilometers', category: 'length' },
  { from: 'kilometers', to: 'miles', category: 'length' },
  { from: 'feet', to: 'inches', category: 'length' },
  { from: 'inches', to: 'feet', category: 'length' },
  { from: 'yards', to: 'feet', category: 'length' },
  { from: 'feet', to: 'yards', category: 'length' },
  { from: 'nautical-miles', to: 'kilometers', category: 'length' },
  { from: 'kilometers', to: 'nautical-miles', category: 'length' },

  // Area
  { from: 'square-centimeters', to: 'square-meters', category: 'area' },
  { from: 'square-meters', to: 'square-centimeters', category: 'area' },
  { from: 'square-meters', to: 'hectares', category: 'area' },
  { from: 'hectares', to: 'square-meters', category: 'area' },
  { from: 'square-kilometers', to: 'hectares', category: 'area' },
  { from: 'hectares', to: 'square-kilometers', category: 'area' },
  { from: 'square-inches', to: 'square-centimeters', category: 'area' },
  { from: 'square-centimeters', to: 'square-inches', category: 'area' },
  { from: 'square-feet', to: 'square-meters', category: 'area' },
  { from: 'square-meters', to: 'square-feet', category: 'area' },
  { from: 'acres', to: 'hectares', category: 'area' },
  { from: 'hectares', to: 'acres', category: 'area' },
  { from: 'square-miles', to: 'square-kilometers', category: 'area' },
  { from: 'square-kilometers', to: 'square-miles', category: 'area' },

  // Volume
  { from: 'milliliters', to: 'liters', category: 'volume' },
  { from: 'liters', to: 'milliliters', category: 'volume' },
  { from: 'cubic-centimeters', to: 'milliliters', category: 'volume' },
  { from: 'milliliters', to: 'cubic-centimeters', category: 'volume' },
  { from: 'liters', to: 'cubic-meters', category: 'volume' },
  { from: 'cubic-meters', to: 'liters', category: 'volume' },
  { from: 'us-fluid-ounces', to: 'milliliters', category: 'volume' },
  { from: 'milliliters', to: 'us-fluid-ounces', category: 'volume' },
  { from: 'imperial-fluid-ounces', to: 'milliliters', category: 'volume' },
  { from: 'milliliters', to: 'imperial-fluid-ounces', category: 'volume' },
  { from: 'us-pints', to: 'liters', category: 'volume' },
  { from: 'liters', to: 'us-pints', category: 'volume' },
  { from: 'imperial-pints', to: 'liters', category: 'volume' },
  { from: 'liters', to: 'imperial-pints', category: 'volume' },
  { from: 'us-quarts', to: 'liters', category: 'volume' },
  { from: 'liters', to: 'us-quarts', category: 'volume' },
  { from: 'imperial-quarts', to: 'liters', category: 'volume' },
  { from: 'liters', to: 'imperial-quarts', category: 'volume' },
  { from: 'us-gallons', to: 'liters', category: 'volume' },
  { from: 'liters', to: 'us-gallons', category: 'volume' },
  { from: 'imperial-gallons', to: 'liters', category: 'volume' },
  { from: 'liters', to: 'imperial-gallons', category: 'volume' },

  // Mass
  { from: 'grams', to: 'kilograms', category: 'mass' },
  { from: 'kilograms', to: 'grams', category: 'mass' },
  { from: 'kilograms', to: 'metric-tons', category: 'mass' },
  { from: 'metric-tons', to: 'kilograms', category: 'mass' },
  { from: 'ounces', to: 'grams', category: 'mass' },
  { from: 'grams', to: 'ounces', category: 'mass' },
  { from: 'pounds', to: 'kilograms', category: 'mass' },
  { from: 'kilograms', to: 'pounds', category: 'mass' },
  { from: 'stones', to: 'kilograms', category: 'mass' },
  { from: 'kilograms', to: 'stones', category: 'mass' },
  { from: 'pounds', to: 'ounces', category: 'mass' },
  { from: 'ounces', to: 'pounds', category: 'mass' },
  { from: 'us-tons', to: 'kilograms', category: 'mass' },
  { from: 'kilograms', to: 'us-tons', category: 'mass' },
  { from: 'uk-tons', to: 'kilograms', category: 'mass' },
  { from: 'kilograms', to: 'uk-tons', category: 'mass' },

  // Temperature
  { from: 'celsius', to: 'fahrenheit', category: 'temperature' },
  { from: 'fahrenheit', to: 'celsius', category: 'temperature' },
  { from: 'celsius', to: 'kelvin', category: 'temperature' },
  { from: 'kelvin', to: 'celsius', category: 'temperature' },
  { from: 'fahrenheit', to: 'kelvin', category: 'temperature' },
  { from: 'kelvin', to: 'fahrenheit', category: 'temperature' },

  // Speed
  { from: 'meters-per-second', to: 'kilometers-per-hour', category: 'speed' },
  { from: 'kilometers-per-hour', to: 'meters-per-second', category: 'speed' },
  { from: 'miles-per-hour', to: 'kilometers-per-hour', category: 'speed' },
  { from: 'kilometers-per-hour', to: 'miles-per-hour', category: 'speed' },
  { from: 'knots', to: 'kilometers-per-hour', category: 'speed' },
  { from: 'kilometers-per-hour', to: 'knots', category: 'speed' },
  { from: 'feet-per-second', to: 'meters-per-second', category: 'speed' },
  { from: 'meters-per-second', to: 'feet-per-second', category: 'speed' },
  { from: 'miles-per-hour', to: 'feet-per-second', category: 'speed' },
  { from: 'feet-per-second', to: 'miles-per-hour', category: 'speed' },

  // Time
  { from: 'seconds', to: 'minutes', category: 'time' },
  { from: 'minutes', to: 'seconds', category: 'time' },
  { from: 'minutes', to: 'hours', category: 'time' },
  { from: 'hours', to: 'minutes', category: 'time' },
  { from: 'hours', to: 'days', category: 'time' },
  { from: 'days', to: 'hours', category: 'time' },
  { from: 'days', to: 'weeks', category: 'time' },
  { from: 'weeks', to: 'days', category: 'time' },
  { from: 'milliseconds', to: 'seconds', category: 'time' },
  { from: 'seconds', to: 'milliseconds', category: 'time' },
  { from: 'microseconds', to: 'milliseconds', category: 'time' },
  { from: 'milliseconds', to: 'microseconds', category: 'time' },

  // Pressure
  { from: 'pascals', to: 'kilopascals', category: 'pressure' },
  { from: 'kilopascals', to: 'pascals', category: 'pressure' },
  { from: 'kilopascals', to: 'bar', category: 'pressure' },
  { from: 'bar', to: 'kilopascals', category: 'pressure' },
  { from: 'bar', to: 'psi', category: 'pressure' },
  { from: 'psi', to: 'bar', category: 'pressure' },
  { from: 'pascals', to: 'psi', category: 'pressure' },
  { from: 'psi', to: 'pascals', category: 'pressure' },
  { from: 'atmospheres', to: 'pascals', category: 'pressure' },
  { from: 'pascals', to: 'atmospheres', category: 'pressure' },
  { from: 'atmospheres', to: 'bar', category: 'pressure' },
  { from: 'bar', to: 'atmospheres', category: 'pressure' },
  { from: 'torr', to: 'pascals', category: 'pressure' },
  { from: 'pascals', to: 'torr', category: 'pressure' },

  // Energy
  { from: 'joules', to: 'kilojoules', category: 'energy' },
  { from: 'kilojoules', to: 'joules', category: 'energy' },
  { from: 'joules', to: 'calories', category: 'energy' },
  { from: 'calories', to: 'joules', category: 'energy' },
  { from: 'joules', to: 'kilocalories', category: 'energy' },
  { from: 'kilocalories', to: 'joules', category: 'energy' },
  { from: 'kilowatt-hours', to: 'joules', category: 'energy' },
  { from: 'joules', to: 'kilowatt-hours', category: 'energy' },
  { from: 'kilowatt-hours', to: 'megajoules', category: 'energy' },
  { from: 'megajoules', to: 'kilowatt-hours', category: 'energy' },
  { from: 'btu', to: 'joules', category: 'energy' },
  { from: 'joules', to: 'btu', category: 'energy' },

  // Power
  { from: 'watts', to: 'kilowatts', category: 'power' },
  { from: 'kilowatts', to: 'watts', category: 'power' },
  { from: 'kilowatts', to: 'metric-horsepower', category: 'power' },
  { from: 'metric-horsepower', to: 'kilowatts', category: 'power' },
  { from: 'kilowatts', to: 'mechanical-horsepower', category: 'power' },
  { from: 'mechanical-horsepower', to: 'kilowatts', category: 'power' },
  { from: 'watts', to: 'btu-per-hour', category: 'power' },
  { from: 'btu-per-hour', to: 'watts', category: 'power' },

  // Data Storage
  { from: 'bytes', to: 'kilobytes', category: 'data' },
  { from: 'kilobytes', to: 'bytes', category: 'data' },
  { from: 'kilobytes', to: 'megabytes', category: 'data' },
  { from: 'megabytes', to: 'kilobytes', category: 'data' },
  { from: 'megabytes', to: 'gigabytes', category: 'data' },
  { from: 'gigabytes', to: 'megabytes', category: 'data' },
  { from: 'gigabytes', to: 'terabytes', category: 'data' },
  { from: 'terabytes', to: 'gigabytes', category: 'data' },
  { from: 'bits', to: 'bytes', category: 'data' },
  { from: 'bytes', to: 'bits', category: 'data' },

  // Cooking
  { from: 'us-teaspoons', to: 'milliliters', category: 'cooking' },
  { from: 'milliliters', to: 'us-teaspoons', category: 'cooking' },
  { from: 'us-tablespoons', to: 'milliliters', category: 'cooking' },
  { from: 'milliliters', to: 'us-tablespoons', category: 'cooking' },
  { from: 'us-cups', to: 'milliliters', category: 'cooking' },
  { from: 'milliliters', to: 'us-cups', category: 'cooking' },
  { from: 'us-cups', to: 'liters', category: 'cooking' },
  { from: 'liters', to: 'us-cups', category: 'cooking' },
  { from: 'us-fluid-ounces', to: 'milliliters', category: 'cooking' },
  { from: 'milliliters', to: 'us-fluid-ounces', category: 'cooking' },
  { from: 'us-pints', to: 'milliliters', category: 'cooking' },
  { from: 'milliliters', to: 'us-pints', category: 'cooking' },
  { from: 'us-quarts', to: 'liters', category: 'cooking' },
  { from: 'liters', to: 'us-quarts', category: 'cooking' },
  { from: 'us-gallons', to: 'liters', category: 'cooking' },
  { from: 'liters', to: 'us-gallons', category: 'cooking' },
  { from: 'ounces', to: 'grams', category: 'cooking' },
  { from: 'grams', to: 'ounces', category: 'cooking' },
  { from: 'pounds', to: 'grams', category: 'cooking' },
  { from: 'grams', to: 'pounds', category: 'cooking' },
  { from: 'us-teaspoons', to: 'us-tablespoons', category: 'cooking' },
  { from: 'us-tablespoons', to: 'us-teaspoons', category: 'cooking' },
  { from: 'us-cups', to: 'us-fluid-ounces', category: 'cooking' },
  { from: 'us-fluid-ounces', to: 'us-cups', category: 'cooking' }
];

export const convert = (value: number, from: string, to: string): number => {
  const conversions: { [key: string]: (val: number) => number } = {
    // Length
    'millimeters-centimeters': (val) => val / 10,
    'centimeters-millimeters': (val) => val * 10,
    'centimeters-meters': (val) => val / 100,
    'meters-centimeters': (val) => val * 100,
    'meters-kilometers': (val) => val / 1000,
    'kilometers-meters': (val) => val * 1000,
    'inches-centimeters': (val) => val * 2.54,
    'centimeters-inches': (val) => val / 2.54,
    'feet-meters': (val) => val * 0.3048,
    'meters-feet': (val) => val / 0.3048,
    'yards-meters': (val) => val * 0.9144,
    'meters-yards': (val) => val / 0.9144,
    'miles-kilometers': (val) => val * 1.60934,
    'kilometers-miles': (val) => val / 1.60934,
    'feet-inches': (val) => val * 12,
    'inches-feet': (val) => val / 12,
    'yards-feet': (val) => val * 3,
    'feet-yards': (val) => val / 3,
    'nautical-miles-kilometers': (val) => val * 1.852,
    'kilometers-nautical-miles': (val) => val / 1.852,
    
    // Area
    'square-centimeters-square-meters': (val) => val / 10000,
    'square-meters-square-centimeters': (val) => val * 10000,
    'square-meters-hectares': (val) => val / 10000,
    'hectares-square-meters': (val) => val * 10000,
    'square-kilometers-hectares': (val) => val * 100,
    'hectares-square-kilometers': (val) => val / 100,
    'square-inches-square-centimeters': (val) => val * 6.4516,
    'square-centimeters-square-inches': (val) => val / 6.4516,
    'square-feet-square-meters': (val) => val * 0.092903,
    'square-meters-square-feet': (val) => val / 0.092903,
    'acres-hectares': (val) => val * 0.404686,
    'hectares-acres': (val) => val / 0.404686,
    'square-miles-square-kilometers': (val) => val * 2.58999,
    'square-kilometers-square-miles': (val) => val / 2.58999,

    // Volume
    'milliliters-liters': (val) => val / 1000,
    'liters-milliliters': (val) => val * 1000,
    'cubic-centimeters-milliliters': (val) => val,
    'milliliters-cubic-centimeters': (val) => val,
    'liters-cubic-meters': (val) => val / 1000,
    'cubic-meters-liters': (val) => val * 1000,
    'us-fluid-ounces-milliliters': (val) => val * 29.5735,
    'milliliters-us-fluid-ounces': (val) => val / 29.5735,
    'imperial-fluid-ounces-milliliters': (val) => val * 28.4131,
    'milliliters-imperial-fluid-ounces': (val) => val / 28.4131,
    'us-pints-liters': (val) => val * 0.473176,
    'liters-us-pints': (val) => val / 0.473176,
    'imperial-pints-liters': (val) => val * 0.568261,
    'liters-imperial-pints': (val) => val / 0.568261,
    'us-quarts-liters': (val) => val * 0.946353,
    'liters-us-quarts': (val) => val / 0.946353,
    'imperial-quarts-liters': (val) => val * 1.13652,
    'liters-imperial-quarts': (val) => val / 1.13652,
    'us-gallons-liters': (val) => val * 3.78541,
    'liters-us-gallons': (val) => val / 3.78541,
    'imperial-gallons-liters': (val) => val * 4.54609,
    'liters-imperial-gallons': (val) => val / 4.54609,

    // Mass
    'grams-kilograms': (val) => val / 1000,
    'kilograms-grams': (val) => val * 1000,
    'kilograms-metric-tons': (val) => val / 1000,
    'metric-tons-kilograms': (val) => val * 1000,
    'ounces-grams': (val) => val * 28.3495,
    'grams-ounces': (val) => val / 28.3495,
    'pounds-kilograms': (val) => val * 0.453592,
    'kilograms-pounds': (val) => val / 0.453592,
    'stones-kilograms': (val) => val * 6.35029,
    'kilograms-stones': (val) => val / 6.35029,
    'pounds-ounces': (val) => val * 16,
    'ounces-pounds': (val) => val / 16,
    'us-tons-kilograms': (val) => val * 907.185,
    'kilograms-us-tons': (val) => val / 907.185,
    'uk-tons-kilograms': (val) => val * 1016.05,
    'kilograms-uk-tons': (val) => val / 1016.05,

    // Temperature
    'celsius-fahrenheit': (val) => (val * 9/5) + 32,
    'fahrenheit-celsius': (val) => (val - 32) * 5/9,
    'celsius-kelvin': (val) => val + 273.15,
    'kelvin-celsius': (val) => val - 273.15,
    'fahrenheit-kelvin': (val) => (val - 32) * 5/9 + 273.15,
    'kelvin-fahrenheit': (val) => (val - 273.15) * 9/5 + 32,

    // Speed
    'meters-per-second-kilometers-per-hour': (val) => val * 3.6,
    'kilometers-per-hour-meters-per-second': (val) => val / 3.6,
    'miles-per-hour-kilometers-per-hour': (val) => val * 1.60934,
    'kilometers-per-hour-miles-per-hour': (val) => val / 1.60934,
    'knots-kilometers-per-hour': (val) => val * 1.852,
    'kilometers-per-hour-knots': (val) => val / 1.852,
    'feet-per-second-meters-per-second': (val) => val * 0.3048,
    'meters-per-second-feet-per-second': (val) => val / 0.3048,
    'miles-per-hour-feet-per-second': (val) => val * 1.46667,
    'feet-per-second-miles-per-hour': (val) => val / 1.46667,

    // Time
    'seconds-minutes': (val) => val / 60,
    'minutes-seconds': (val) => val * 60,
    'minutes-hours': (val) => val / 60,
    'hours-minutes': (val) => val * 60,
    'hours-days': (val) => val / 24,
    'days-hours': (val) => val * 24,
    'days-weeks': (val) => val / 7,
    'weeks-days': (val) => val * 7,
    'milliseconds-seconds': (val) => val / 1000,
    'seconds-milliseconds': (val) => val * 1000,
    'microseconds-milliseconds': (val) => val / 1000,
    'milliseconds-microseconds': (val) => val * 1000,

    // Pressure
    'pascals-kilopascals': (val) => val / 1000,
    'kilopascals-pascals': (val) => val * 1000,
    'kilopascals-bar': (val) => val / 100,
    'bar-kilopascals': (val) => val * 100,
    'bar-psi': (val) => val * 14.5038,
    'psi-bar': (val) => val / 14.5038,
    'pascals-psi': (val) => val / 6894.76,
    'psi-pascals': (val) => val * 6894.76,
    'atmospheres-pascals': (val) => val * 101325,
    'pascals-atmospheres': (val) => val / 101325,
    'atmospheres-bar': (val) => val * 1.01325,
    'bar-atmospheres': (val) => val / 1.01325,
    'torr-pascals': (val) => val * 133.322,
    'pascals-torr': (val) => val / 133.322,

    // Energy
    'joules-kilojoules': (val) => val / 1000,
    'kilojoules-joules': (val) => val * 1000,
    'joules-calories': (val) => val / 4.184,
    'calories-joules': (val) => val * 4.184,
    'joules-kilocalories': (val) => val / 4184,
    'kilocalories-joules': (val) => val * 4184,
    'kilowatt-hours-joules': (val) => val * 3600000,
    'joules-kilowatt-hours': (val) => val / 3600000,
    'kilowatt-hours-megajoules': (val) => val * 3.6,
    'megajoules-kilowatt-hours': (val) => val / 3.6,
    'btu-joules': (val) => val * 1055.06,
    'joules-btu': (val) => val / 1055.06,

    // Power
    'watts-kilowatts': (val) => val / 1000,
    'kilowatts-watts': (val) => val * 1000,
    'kilowatts-metric-horsepower': (val) => val * 1.35962,
    'metric-horsepower-kilowatts': (val) => val / 1.35962,
    'kilowatts-mechanical-horsepower': (val) => val * 1.34102,
    'mechanical-horsepower-kilowatts': (val) => val / 1.34102,
    'watts-btu-per-hour': (val) => val * 3.41214,
    'btu-per-hour-watts': (val) => val / 3.41214,

    // Data Storage
    'bytes-kilobytes': (val) => val / 1024,
    'kilobytes-bytes': (val) => val * 1024,
    'kilobytes-megabytes': (val) => val / 1024,
    'megabytes-kilobytes': (val) => val * 1024,
    'megabytes-gigabytes': (val) => val / 1024,
    'gigabytes-megabytes': (val) => val * 1024,
    'gigabytes-terabytes': (val) => val / 1024,
    'terabytes-gigabytes': (val) => val * 1024,
    'bits-bytes': (val) => val / 8,
    'bytes-bits': (val) => val * 8,

    // Cooking
    'us-teaspoons-milliliters': (val) => val * 4.92892,
    'milliliters-us-teaspoons': (val) => val / 4.92892,
    'us-tablespoons-milliliters': (val) => val * 14.7868,
    'milliliters-us-tablespoons': (val) => val / 14.7868,
    'us-cups-milliliters': (val) => val * 236.588,
    'milliliters-us-cups': (val) => val / 236.588,
    'us-cups-liters': (val) => val * 0.236588,
    'liters-us-cups': (val) => val / 0.236588,
    'us-teaspoons-us-tablespoons': (val) => val / 3,
    'us-tablespoons-us-teaspoons': (val) => val * 3,
    'us-cups-us-fluid-ounces': (val) => val * 8,
    'us-fluid-ounces-us-cups': (val) => val / 8,
  };

  const key = `${from}-${to}`;
  return conversions[key] ? conversions[key](value) : value;
};
